import store from 'app/core/store';
import _ from 'lodash';
import config from 'app/core/config';

export class ImpressionSrv {
  constructor() {}

  addDashboardImpression(dashboardId, dashUrl) {
    store.set(this.lastUrlKey(), dashUrl);

    var impressionsKey = this.impressionKey();
    var impressions = [];
    if (store.exists(impressionsKey)) {
      impressions = JSON.parse(store.get(impressionsKey));
      if (!_.isArray(impressions)) {
        impressions = [];
      }
    }

    impressions = impressions.filter(imp => {
      return dashboardId !== imp;
    });

    impressions.unshift(dashboardId);

    if (impressions.length > 50) {
      impressions.pop();
    }
    store.set(impressionsKey, JSON.stringify(impressions));
  }

  getDashboardOpened() {
    var impressions = store.get(this.impressionKey()) || '[]';

    impressions = JSON.parse(impressions);

    impressions = _.filter(impressions, el => {
      return _.isNumber(el);
    });

    return impressions;
  }

  getLastDashUrl() {
    return store.get(this.lastUrlKey());
  }

  impressionKey() {
    return 'dashboard_impressions-' + config.bootData.user.orgId;
  }

  lastUrlKey() {
    return 'last_dash_url-' + config.bootData.user.orgId;
  }
}

const impressionSrv = new ImpressionSrv();
export default impressionSrv;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/impression_srv.ts